'use strict'

/**
 *
 * @name: nnHonourees
 *
 */

import DirectiveTemplate from './nn-honourees.directive.html'
import './nn-honourees.directive.scss'

function NnHonoureesDirective () {

  'ngInject'

  return {
    restrict: 'A',
    replace: true,
    scope: {
      content: '&',
      loaded: '='
    },
    transclude: true,
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $element) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */
  $scope.item = $scope.content();
  $scope.list = $scope.item.jsonData.honourees;
  $scope.columns = $scope.item.jsonData.columns
  $scope.loaded = true;
  $scope.columnWidth = (100 / $scope.columns).toFixed(2) + '%'

  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */

  function _terminate() {
    $scope.$destroy();
    $element.remove();
  }


  /*
   *
   * @INIT
   *
   */

  if (!$scope.list.length) {
    _terminate()
  }
}

export default NnHonoureesDirective



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-honourees/nn-honourees.directive.js